/**
 * Map flat validation keys from a parent ContentEditor (e.g. exercises.0.data.question)
 * onto nested element editors (e.g. question).
 */

/** Dot-separated path without trailing dot, e.g. `exercises.0.data` */
export function pickErrorsUnderPrefix(
    errors: Record<string, string> | undefined,
    prefix: string,
): Record<string, string> | undefined {
    if (!errors || !prefix) {
        return undefined;
    }
    const base = prefix.endsWith('.') ? prefix.slice(0, -1) : prefix;
    const withDot = `${base}.`;
    const out: Record<string, string> = {};
    for (const [key, message] of Object.entries(errors)) {
        if (key.startsWith(withDot)) {
            const suffix = key.slice(withDot.length);
            if (suffix) {
                out[suffix] = message;
            }
        }
    }
    return Object.keys(out).length > 0 ? out : undefined;
}

/** Prefix for one exercise’s element data: `exercises.${index}.data` */
export function exerciseDataErrorsPrefix(exerciseIndex: number): string {
    return `exercises.${exerciseIndex}.data`;
}

export function hasErrorsForExerciseIndex(
    errors: Record<string, string> | undefined,
    exerciseIndex: number,
): boolean {
    if (!errors) {
        return false;
    }
    const p = exerciseDataErrorsPrefix(exerciseIndex);
    return Object.keys(errors).some((k) => k === p || k.startsWith(`${p}.`));
}
